import React from 'react';

const Placeholder = () => (
  <div className="mt-8 px-8 mx-auto w-full max-w-4xl">
    <div className="mb-8 h-1/2 bg-gray-100 rounded w-full" />
    <div className="space-y-2 mb-4">
      <div className="h-6 bg-gray-100 rounded w-4/5" />
      <div className="h-4 bg-gray-100 rounded w-3/5" />
      <div className="h-4 bg-gray-100 rounded w-4/5" />
      <div className="h-4 bg-gray-100 rounded w-3/5" />
    </div>
  </div>
);

export default Placeholder;
